import { Action } from 'redux'
import { CalendarActions } from '../../../reducers/bookingCalendar/actionNames'

export const fetchCalendars = (): IFetchCalendars => ({
  type: CalendarActions.FetchUserCalendars,
})
export type IFetchCalendars = Action<CalendarActions.FetchUserCalendars>

export const calendarsFetched = (calendarId: number): ICalendarsFetched => ({
  calendarId,
  type: CalendarActions.CalendarsFetched,
})

export interface ICalendarsFetched
  extends Action<CalendarActions.CalendarsFetched> {
  calendarId: number
}
